export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },

    color: {
      type: String,
      default: 'primary-500'
    },

    /**
     * Show a tooltip with the search button
     */
    searchTooltip: {
      type: String,
      default: null,
    },
    search: String,
    showSearch: Boolean,
    bordered: Boolean,
    striped: Boolean,
    narrowed: Boolean,
    hoverable: Boolean,
    loading: Boolean,
    detailed: Boolean,
    checkable: Boolean,
    selected: Object,
    focusable: Boolean,
    customIsChecked: Function,
    isRowCheckable: {
      type: Function,
      default: () => true,
    },
    checkedRows: {
      type: Array,
      default: () => [],
    },
    mobileCards: {
      type: Boolean,
      default: true,
    },
    defaultSort: [String, Array],
    defaultSortDirection: {
      type: String,
      default: 'asc',
    },
    paginated: Boolean,
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: [Number, String],
      default: 20,
    },
    showDetailIcon: {
      type: Boolean,
      default: true,
    },
    paginationSimple: Boolean,
    paginationSize: String,
    backendSorting: Boolean,
    rowClass: {
      type: Function,
      default: () => '',
    },
    openedDetailed: {
      type: Array,
      default: () => [],
    },
    hasDetailedVisible: {
      type: Function,
      default: () => true,
    },
    detailKey: {
      type: String,
      default: '',
    },
    backendPagination: Boolean,
    total: {
      type: [Number, String],
      default: 0,
    },
    iconPack: {
      type: String,
      default: 'fas',
    },
    mobileSortPlaceholder: String,
    customRowKey: String,
    draggable: {
      type: Boolean,
      defualt: false,
    },
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String,
    backendSearch: {
      type: Boolean,
      default: false,
    },
  },
};